import { useLocation, Link, useHistory } from "react-router-dom";
import { ArrowRightIcon } from "../../../../../components/icons";
const NotificationItem = ({
  title,
  description,
  id,
  checkStatus = false,
  handleDetailButton
}) => {

const history = useHistory();

const isMobileView = window.innerWidth <= 768; // Example threshold for mobile view

const handleClick = () => {
  const path = isMobileView ? '/notifications/' : '/my-page/notifications/';
  history.push(path + id);
};
  return (
    <div className={"tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)] tw:mb-4 " + (!checkStatus ? "border-gold" : "")}>
      <div className="tw:flex-1 tw:p-4">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-center">
          <div className="tw:px-[calc(var(--gx)/2)] tw:sm:w-full tw:sm:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:lg:grow tw:lg:w-auto tw:my-2">
            <b>{title}</b>
            <p className="tw:mt-2">
              {description.substring(0, 82) + '...'}
            </p>
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-auto tw:lg:flex-none">
            <div className="tw:grid tw:gap-2">
              <button
                type="button"
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none bg-gold-light-100 tw:rounded-[0.375rem] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
              >
                <div className="tw:flex tw:items-center tw:justify-center tw:px-2" onClick={() => handleClick() } >
                  View Detail
                  <i className="tw:pl-2">
                    <ArrowRightIcon color="#4A4A4A" size={24} />
                  </i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
